import axios from 'axios';
import AxiosConfig from '../utils/axios';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  /**
   * See if there are any notifications for unread comments
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getCommentsNotifications(projectId, applicationNamespace) {
    const axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise((resolve, reject) => {
      const url = `${apiUrl}/v1/${applicationNamespace}/notifications/unread_comments/${projectId}`;
      axios.get(url, axiosConfig)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  /**
   * get notifications for unread quote edits
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getEditsNotifications(projectId, applicationNamespace) {
    const axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise((resolve, reject) => {
      const url = `${apiUrl}/v1/${applicationNamespace}/notifications/unread_edits/${projectId}`;
      axios.get(url, axiosConfig)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  /**
   * Clear out the notifications for unread comments
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  clearCommentNotifications(projectId, applicationNamespace) {
    const axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise((resolve, reject) => {
      const url = `${apiUrl}/v1/${applicationNamespace}/notifications/mark_all_comments_as_read`;
      const data = {
        project_id: projectId,
      };
      axios.post(url, data, axiosConfig)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  /**
   * Clear out the notifications for unread quote edits
   *
   * @param {number} projectId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  clearEditNotifications(projectId, applicationNamespace) {
    const axiosConfig = AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE);
    return new Promise((resolve, reject) => {
      const url = `${apiUrl}/v1/${applicationNamespace}/notifications/mark_all_edits_as_read`;
      const data = {
        project_id: projectId,
      };
      axios.post(url, data, axiosConfig)
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
};
